import { POLICY_EFFECT_STRING_ENUM } from 'pages/assetManager/constants'

export const getPolicyEffectDisplayText = (url: string) => {
  return POLICY_EFFECT_STRING_ENUM[url as keyof typeof POLICY_EFFECT_STRING_ENUM]
}
